import { CalculatorPromptDB, CalculatorPromptUI } from '../../calculator/store/types';

export enum ClientCalculatorActionTypes {
    FETCH_CLIENT_CALCULATOR_PROMPTS_STARTED = 'FETCH_CLIENT_CALCULATOR_PROMPTS_STARTED',
    FETCH_CLIENT_CALCULATOR_PROMPTS_SUCCESSFUL = 'FETCH_CLIENT_CALCULATOR_PROMPTS_SUCCESSFUL',
    FETCH_CLIENT_CALCULATOR_PROMPTS_FAILED = 'FETCH_CLIENT_CALCULATOR_PROMPTS_FAILED',
    UPSERT_CLIENT_CALCULATOR_PROMPT_STARTED = 'UPSERT_CLIENT_CALCULATOR_PROMPT_STARTED',
    UPSERT_CLIENT_CALCULATOR_PROMPT_SUCCESSFUL = 'UPSERT_CLIENT_CALCULATOR_PROMPT_SUCCESSFUL',
    UPSERT_CLIENT_CALCULATOR_PROMPT_FAILED = 'UPSERT_CLIENT_CALCULATOR_PROMPT_FAILED',
    DELETE_CLIENT_CALCULATOR_PROMPT_STARTED = 'DELETE_CLIENT_CALCULATOR_PROMPT_STARTED',
    DELETE_CLIENT_CALCULATOR_PROMPT_SUCCESSFUL = 'DELETE_CLIENT_CALCULATOR_PROMPT_SUCCESSFUL',
    DELETE_CLIENT_CALCULATOR_PROMPT_FAILED = 'DELETE_CLIENT_CALCULATOR_PROMPT_FAILED',
    UPDATE_SELECTED_CLIENT_CALCULATOR_PROMPT = 'UPDATE_SELECTED_CLIENT_CALCULATOR_PROMPT',
    TOGGLE_DELETE_CLIENT_CALCULATOR_PROMPT_CONFIRMATION_MODAL = 'TOGGLE_DELETE_CLIENT_CALCULATOR_PROMPT_CONFIRMATION_MODAL',
    SET_SELECTED_CLIENT_CALCULATOR_PROMPT_UPDATED = 'SET_SELECTED_CLIENT_CALCULATOR_PROMPT_UPDATED',
    SELECT_CLIENT_CALCULATOR_PROMPT = 'SELECT_CLIENT_CALCULATOR_PROMPT',
    SET_CLIENT_CALCULATOR_PROMPT_ORDER = 'SET_CLIENT_CALCULATOR_PROMPT_ORDER',
    UPDATE_CLIENT_CALCULATOR_PROMPT_ORDER = 'UPDATE_CLIENT_CALCULATOR_PROMPT_ORDER',
    SAVE_CLIENT_PROMPT_ORDER_STARTED = 'SAVE_CLIENT_PROMPT_ORDER_STARTED',
    SAVE_CLIENT_PROMPT_ORDER_SUCCESSFUL = 'SAVE_CLIENT_PROMPT_ORDER_SUCCESSFUL',
    SAVE_CLIENT_PROMPT_ORDER_FAILED = 'SAVE_CLIENT_PROMPT_ORDER_FAILED',
    DUPLICATE_SYSTEM_PROMPT = 'DUPLICATE_SYSTEM_PROMPT'
}

export interface ClientCalculatorState {
    isFetchingCalculatorPrompts: boolean;
    isSavingCalculatorPrompt: boolean;
    isDeletingCalculatorPrompt: boolean;
    calculatorPrompts: CalculatorPromptDB[];
    selectedCalculatorPrompt: CalculatorPromptUI | null;
    calculatorPromptToDelete: CalculatorPromptDB | null;
    selectedPromptUpdated: boolean;
    showCalculatorPreview: boolean;
    currentSelectedFieldTypePromptOrder: CalculatorPromptDB[];
    savedSelectedFieldTypePromptOrder: CalculatorPromptDB[];
}
